/* ============================================================
   impressed — luxury scroll colour driver
   - Toggles html.lux-scrolled past 24px (header glass morph).
   - Drives the #lux-progress champagne line (scaleX).
   - Adds .lux-revealed to sections as they enter the viewport
     (warm settle). Reduced-motion users get the settled state
     immediately, with no observer.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;

  var bar = document.createElement('div');
  bar.id = 'lux-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  var ticking = false;
  function update() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset || 0;
    root.classList.toggle('lux-scrolled', y > 24);
    root.classList.toggle('lux-shrunk', y > 140);
    var max = root.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
    bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections = document.querySelectorAll('.shopify-section');
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lux-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    sections.forEach(function (s) { io.observe(s); });
  } else {
    sections.forEach(function (s) { s.classList.add('lux-revealed'); });
  }
})();
